export const showdownOptions = {
  tables: true,
  emoji: true,
  strikethrough: true,
  openLinksInNewWindow: true,
  extensions: [],
};
